"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ScreenJson = _interopRequireDefault(require("@ikea-aoa/ikea-shared-styles/lib/variables/Screen.json.js"));

var _EventHandler2 = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/event/EventHandler"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var SCREEN = Object.assign({}, _ScreenJson.default);
var SCREEN_KEYS = Object.keys(_ScreenJson.default);

for (var _i = 0, _SCREEN_KEYS = SCREEN_KEYS; _i < _SCREEN_KEYS.length; _i++) {
  var key = _SCREEN_KEYS[_i];
  SCREEN[key] = parseInt(SCREEN[key].replace('px', ''));
}
/**
 * Component resize handler.
 */


var ComponentResizeHandler = /*#__PURE__*/function (_EventHandler) {
  _inherits(ComponentResizeHandler, _EventHandler);

  var _super = _createSuper(ComponentResizeHandler);

  /**
   * Class constructor.
   *
   * @param {string} componentName Component name.
   */
  function ComponentResizeHandler(componentName) {
    _classCallCheck(this, ComponentResizeHandler);

    return _super.call(this, {
      supportedEvents: ['resize'],
      componentName: componentName
    });
  }
  /**
   * Adds an event listener.
   *
   * @param {string} name Event name.
   * @param {Function} listener The listener.
   */


  _createClass(ComponentResizeHandler, [{
    key: "on",
    value: function on(name, listener) {
      _get(_getPrototypeOf(ComponentResizeHandler.prototype), "on", this).call(this, name, listener);

      if (name === 'resize') {
        this.constructor.subscribe(this);
      }
    }
    /**
     * Returns the current size of the window including breakpoints.
     *
     * @alias ComponentResizeHandler.getCurrentSize
     * @returns {{ breakpoint: { width: string, height: string }, screenWidth: number, screenHeight: number }} Resize data.
     */

  }, {
    key: "getCurrentSize",
    value: function getCurrentSize() {
      return this.constructor.getCurrentSize();
    }
    /**
     * Destroys the body. Disconnects the observer.
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this.constructor.unsubscribe(this);
      this._events.resize = [];
    }
    /**
     * Subscribes to resize.
     *
     * @param {ComponentResizeHandler} resizeHandler Resize handler to subscribe.
     */

  }], [{
    key: "subscribe",
    value: function subscribe(resizeHandler) {
      this._resizeHandlers = this._resizeHandlers || new Map();
      this._resizeListener = this._resizeListener || this._handleResize.bind(this);

      this._resizeHandlers.set(resizeHandler, true);

      window.addEventListener('resize', this._resizeListener);
    }
    /**
     * Unsubscribes to resize.
     *
     * @param {ComponentResizeHandler} resizeHandler Resize handler to unsubscribe.
     */

  }, {
    key: "unsubscribe",
    value: function unsubscribe(resizeHandler) {
      this._resizeHandlers = this._resizeHandlers || new Map();

      this._resizeHandlers.delete(resizeHandler);

      if (this._resizeHandlers.size === 0) {
        window.removeEventListener('resize', this._resizeListener);
        clearTimeout(this._debounceTimeout);
      }
    }
    /**
     * Returns the current size of the window including breakpoints.
     *
     * @alias ComponentResizeHandler.getCurrentSize
     * @returns {{ breakpoint: { width: string, height: string }, screenWidth: number, screenHeight: number }} Resize data.
     */

  }, {
    key: "getCurrentSize",
    value: function getCurrentSize() {
      var self = this;
      var breakpoints;
      return {
        screenWidth: window.innerWidth,
        screenHeight: window.innerHeight,

        get breakpoints() {
          breakpoints = breakpoints || self._getBreakpoints();
          return breakpoints;
        }

      };
    }
    /**
     * Returns the breakpoints for a screen width.
     *
     * @returns {{ width: string, height: string }} Breakpoints.
     */

  }, {
    key: "_getBreakpoints",
    value: function _getBreakpoints() {
      var breakpoints = {
        width: null,
        height: null
      };
      var screenWidth = window.innerWidth;
      var screenHeight = window.innerHeight;

      var _iterator = _createForOfIteratorHelper(SCREEN_KEYS),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _key = _step.value;

          if (screenWidth <= SCREEN[_key]) {
            breakpoints.width = _key;
          }

          if (screenHeight <= SCREEN[_key]) {
            breakpoints.height = _key;
          }

          if (breakpoints.width !== null && breakpoints.height !== null) {
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return breakpoints;
    }
    /**
     * Handles a resize.
     */

  }, {
    key: "_handleResize",
    value: function _handleResize() {
      var _this = this;

      clearTimeout(this._debounceTimeout);
      this._debounceTimeout = setTimeout(function () {
        var resizeData = _this.getCurrentSize();

        var _iterator2 = _createForOfIteratorHelper(_this._resizeHandlers),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _step2$value = _slicedToArray(_step2.value, 1),
                resizeHandler = _step2$value[0];

            resizeHandler.trigger('resize', resizeData);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      });
    }
  }]);

  return ComponentResizeHandler;
}(_EventHandler2.default);

exports.default = ComponentResizeHandler;